import api from './api';

export const getTeamMembers = async () => {
  const response = await api.get('/auth/account/members');
  return response.data;
};

export const addTeamMember = async (data) => {
  const response = await api.post('/auth/account/members', data);
  return response.data;
};

export const updateTeamMember = async (id, data) => {
  const response = await api.put(`/auth/account/members/${id}`, data);
  return response.data;
};

export const removeTeamMember = async (id) => {
  const response = await api.delete(`/auth/account/members/${id}`);
  return response.data;
};

export const updateSmsNotifications = async (enabled) => {
  const response = await api.put('/auth/account/sms-notifications', { enabled });
  return response.data;
};
